import Box from '@mui/material/Box';
import backgroundImage from '../assets/img/bg-web.jpg';
import { Icons } from './Icons'
import megaGo from '../assets/icons/megaGo.svg'
import { Button } from '@mui/material';

const backgroundStyle = {
  backgroundImage: `url(${backgroundImage})`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  zIndex: 1112,
};

function ErrorMessage(message) {
  
  const reloadPage = () => {
    window.location.reload()
  }

  return (
    <div style={backgroundStyle}>
      <Box
        className="error-box"
      >
        <Icons path={megaGo} />
        <div>
          <div>
            <p style={{ textAlign: 'center', lineHeight: 1.5, whiteSpace: 'pre-line' }}>{message && message.message}</p>
            <Button
              variant="contained"
              onClick={reloadPage}
              style={{ marginTop: '22px', marginBottom: '18px', fontSize: 20, paddingRight: 80, paddingLeft: 80 }}
            >
              Reintentar ahora
            </Button>
          </div>
        </div>
      </Box>
    </div>
  );
}

export default ErrorMessage;
